import { type RefObject, createContext, useContext } from 'react'

export interface ChatInputShellContextValue {
  textareaRef: RefObject<HTMLTextAreaElement>
  formRef: RefObject<HTMLFormElement>
  submitRef: RefObject<HTMLButtonElement>
  busy: boolean
  disabled: boolean
}

export const ChatInputShellContext = createContext<ChatInputShellContextValue | null>(null)

export function useChatInputShellContext() {
  const ctx = useContext(ChatInputShellContext)
  if (!ctx) {
    throw new Error('ChatInputShell sub-components must be used within <ChatInputShell.Form>')
  }
  return ctx
}
